module.exports = __webpack_public_path__ + "static/target-audience-cc5068a8367bb16a2a31117789f8b91d.png";